import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { Pencil } from 'lucide-react'
import { GetOperatorMemberListTableData } from '@/modules/manage-member/type'
import { useIsCurrentUser } from '@/modules/manage-member/hooks/useIsCurrentUser'

interface EditMemberProps {
	row: GetOperatorMemberListTableData
}

export function EditMember({ row }: EditMemberProps) {
	const isCurrentUser = useIsCurrentUser(row.id)

	if (isCurrentUser) {
		return null
	}

	return (
		<Button variant="ghost" size="icon">
			<Link to={`/operator/manage-member/${row.id}`}>
				<Pencil className="h-4 w-4" />
			</Link>
		</Button>
	)
}
